import { render, staticRenderFns } from "./MetaDataUpdater.vue?vue&type=template&id=3ceae5a9&scoped=true&"
import script from "./MetaDataUpdater.vue?vue&type=script&lang=js&"
export * from "./MetaDataUpdater.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataUpdater.vue?vue&type=style&index=0&id=3ceae5a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceae5a9",
  null
  
)

export default component.exports